import React from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';

import renderViewsState from '../shared/render-views-state';
import Animate from '../shared/animation';
import Calendar from '../shared/calendar/main';

import { selectors as rootSelectors } from '../root';
import { actions, selectors } from './';

const Main = renderViewsState(
	props => (
		<Animate>
			<div className="container__content fin-reports">
				<div className="container__content-title">
					<div className="container__content-title-position">
						<h1 className="title">{props.intl('Points/QUID report')}</h1>
					</div>
				</div>
				<div className="container__content-body">
					<div className="ui-control-bar">
						<div className="ui-control-bar__item modify-item---calendar">
							<div className="ui-control-bar__item-position">
								<Calendar
									{...props.calendar}
									onInit={props.calendarInit}
									onToggle={props.calendarToggle}
									onChange={props.calendarChange}
									onApply={props.calendarApply}
									intl={props.intl}
								/>
							</div>
						</div>
						<div className="ui-control-bar__item">
							<div className="ui-control-bar__item-position">
								<button
									className="ui-btn ui-btn-primary apply"
									onClick={() => props.getReport(false)}
								>
									{props.intl('Points/QUID movement')}
								</button>
							</div>
						</div>
					</div>
				</div>
			</div>
		</Animate>
	),
	'view'
);

export default connect(
	state => ({
		data: selectors.getData(state),
		menuConfig: rootSelectors.getMenuConfig(state),
		calendar: selectors.getCalendar(state),
		intl: selectors.getIntl(state),
		can: selectors.getCan(state),
		error: selectors.getError(state)
	}),
	dispatch => bindActionCreators(actions, dispatch)
)(Main);


// WEBPACK FOOTER //
// ./frontend/admin-dashboard/src/modules/marketing-reports/main.js